/*
 * @Descripttion: 大多数页面用的header 包含 菜单
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-09 15:40:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-01 09:13:55
 */
import React from 'react'
import Logo from './images/logo.png'
import { Menu, Dropdown, Avatar, Badge } from 'antd'
import { Link, Redirect, withRouter } from 'react-router-dom'
import axios from 'axios'
import './height4Style.css'
import { connect } from 'react-redux'
// import { login, logout } from '../../service/loginaction'
import { login, logout } from '../../service/loginaction_yunguan'
import { setCookie, hasCookie, getCookie } from 'src/utils/checkCookie'
import { ShoppingCartOutlined } from '@ant-design/icons';
import {values} from "@babel/runtime/regenerator";

const name_index = { "空基规划": 0, "空基卫星": 1, "共性应用支撑平台": 2, "支撑服务系统": 3, "项目大事记": 4, "团队简介": 5 }

class Header3 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            headMes: {},
            navigationListNew: [],
            titleCn: '',
            titleEn: '',
        }
    }

    componentWillUnmount() {
    }

    componentWillMount() {
    }

    async componentDidMount() {
        let headMes;
        let headMes1;
        // let timer = setInterval(async () => {
        //     let user = this.props.user;
        //     if (Object.keys(user).length !== 0) {
        //         console.log('user信息：', user);
        //
        //         if (!hasCookie('navigationList')) {
        //             let res = await axios.get(global.gatewayip + `/api/protal-service/navigation/menuListByToken?token=${user.token}`)
        //             headMes = res.data.payload
        //             setCookie('HeadMes', res.data.payload)
        //         } else {
        //             headMes = getCookie('HeadMes')
        //         }
        //         console.log('headMes', headMes)
        //         console.log('ceshi', headMes.navigations)
        //         this.setState({
        //             headMes: headMes,
        //             navigationListNew: headMes.navigations,
        //             titleCn: headMes.titleCn,
        //             titleEn: headMes.titleEn,
        //             imgUrl: headMes.imgUrl
        //         })
        //         clearInterval(timer);
        //         // console.log('The timer has been cancelled.');
        //     }
        // }, 100)
        // if (hasCookie('HeadMes')) {
        headMes = JSON.parse(localStorage.getItem('HeadMes'))
        let navigationListTemp=headMes.navigations

        if (headMes) {
            this.setState({
                headMes: headMes,
                navigationListNew: headMes.navigations,
                titleCn: headMes.titleCn,
                titleEn: headMes.titleEn,
                imgUrl: headMes.imgUrl
            })
        }
    }

    setValue = () => {
        let headMes;
        headMes = JSON.parse(localStorage.getItem('HeadMes'))
        console.log('headMes', headMes)
        console.log('ceshi', headMes.navigations)

        this.setState({
            headMes: headMes,
            navigationListNew: headMes.navigations,
            titleCn: headMes.titleCn,
            titleEn: headMes.titleEn,
            imgUrl: headMes.imgUrl
        })
    }

    buildMenu = (menuList) => {
        menuList.map((value, index) => {
            return <Menu.Item>
                <Link to={value.link}>{value.menuName}</Link>
            </Menu.Item>
        })
    }

    //使同一路由下，点击导航栏也能进行跳转
    clickIntroduce = (m_value) => {
        console.log('同一路由跳转：', m_value);
        console.log('检查跳转index', name_index[m_value.menuName]);
        // sessionStorage.setItem('introduceIndex', name_index[m_value.menuName]);
        this.props.history.push({ pathname: '/Guide', })
        this.props.history.push({ pathname: m_value.link, state: { index: m_value.index } })
    }

    finder = (value) => {
        let RouterList = JSON.parse(localStorage.getItem('RouterList'))
        if (Array.isArray(RouterList) && RouterList.length > 0) {
            for (let i = 0; i < RouterList.length; i++) {
                if (RouterList[i].link === value) {
                    let url = RouterList[i].url
                    if (RouterList[i].param) {
                        url += this.generateParamsString(RouterList[i])
                    }
                    return url
                }
            }
        }
    }

    generateParamsString = ({ url, param }) => {
        let params = param.split(';')
        const { user } = this.props
        let resultString = ''
        url.indexOf('?') === -1 ? resultString += '?' : resultString += '&'
        params.map((item, index) => {
            switch (item) {
                case 'token':
                    resultString += 'token=' + user.token + '&'
                    break;
                case 'userToken':
                    resultString += 'userToken=' + user.token + '&'
                    break;
                case 'zd_token':
                    resultString += 'zd_token=' + user.zd_token + '&'
                    break;
                case 'userName':
                    resultString += 'userName=' + user.userName + '&'
                    break;
                case 'userId':
                    resultString += 'userId=' + user.userId + '&'
                    break;
                default:
                    break;
            }
        })
        resultString = resultString.substring(0, resultString.length - 1)
        return resultString
    }
    renderHeadTitle = () => {
        const { SubMenu } = Menu;
        let navigationList
        if (this.state.navigationListNew.length !== 0) {
            navigationList = this.state.navigationListNew
        } else {
            navigationList = []
        }
        // console.log('导航栏数据:',navigationList);
        return (
            navigationList.map((value, index) => {
                // console.log('headMesA', value.menusList)
                return <Dropdown
                    key={`menu1-${index}`}
                    overlay={
                        <Menu>
                            {
                                value.menusList.map((m_value, m_index) => {
                                    if (m_value.type === 'menu') {

                                        return <SubMenu title={m_value.menuName} key={`menu2-${m_index}`}>
                                            {
                                                m_value.menusList.map((mv, mi) => {
                                                    return <Menu.Item
                                                        key={`item-${mi}`}
                                                    >
                                                        {
                                                            mv.type === "blank" ? <a
                                                                target="_blank"
                                                                href={this.finder(mv.link)}
                                                                rel="noopener noreferrer"
                                                            >{mv.menuName}
                                                            </a> : <Link
                                                                to={{
                                                                    pathname: mv.link,
                                                                    // state: { index: mv.index }
                                                                }}>{mv.menuName}</Link>
                                                        }
                                                    </Menu.Item>
                                                })
                                            }
                                        </SubMenu>
                                    } else {
                                        if (m_value.link === '/Introduce') {     //单独的解决办法，目前部署可使用
                                            // m_value.index = m_index;
                                            m_value.index = name_index[m_value.menuName];
                                            return <Menu.Item key={`menu2-${m_index}`}>
                                                <a onClick={() => this.clickIntroduce(m_value)}>{m_value.menuName}</a>
                                            </Menu.Item>
                                        } else
                                            return <Menu.Item key={`menu2-${m_index}`}>
                                                {
                                                    m_value.type === "blank" ?
                                                        <a
                                                            target="_blank"
                                                            href={this.finder(m_value.link)}
                                                            rel="noopener noreferrer"
                                                        >{m_value.menuName}
                                                        </a> :
                                                        <Link
                                                            to={{
                                                                pathname: m_value.link,
                                                                // state: { index: m_value.index }
                                                            }}>{m_value.menuName}
                                                        </Link>
                                                }
                                                {/* <Link
                                                        to={{
                                                            pathname: m_value.link,
                                                            state: { index: m_value.index }
                                                        }}>{m_value.menuName}</Link> */}
                                            </Menu.Item>
                                    }
                                })
                            }
                        </Menu>
                    }
                    placement="bottomLeft"
                >
                    <div className="NewHeader_navigation" key={`menu1-${index}`}>{value.menuName}</div>
                </Dropdown>
            })
        )
    }

    render() {
        const usermenu = <Menu>
            <Menu.Item key="1">
                <Link to='/usercenter/myaccount'>个人中心</Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Link to='/CloudStorage'>个人云盘(我的上传)</Link>
            </Menu.Item>
            {/* <Menu.Item key="3" className='header-menuitem' >
                <Link to='/ManagerCenter/AuthorityManager'>管理中心</Link>
            </Menu.Item> */}
            <Menu.Item>
                <Link to='/chat'>即时通信</Link>
            </Menu.Item>
            <Menu.Item key="4">
                <Link to='/onlineHelp'>在线帮助</Link>
            </Menu.Item>
            <Menu.Item key="5">
                <Link to='/WDDZ'>我的定制</Link>
            </Menu.Item>
            {/* <Menu.Item key="5">
                <a
                    href={'http://adobe.ossd-zh.kuaiyunds.com/adobe/2xin/ps/photoshopcc2021.zip'}
                    target='_blank'
                >
                    {"客户端下载"}
                </a>
            </Menu.Item> */}
            <Menu.Item key="6" onClick={() => this.props.logout(this.props.user)}>
                <a>{"退出登录"}</a>
            </Menu.Item>
        </Menu>
        const messagemenu = <Menu>
            <Menu.Item key="1">
                <Link to='/Q&AMessage'>消息中心 </Link>
            </Menu.Item>
        </Menu>

        const { user } = this.props;
        // console.log('导航栏用户头像文件：',user.avatar)
        // if (true) {
        if (this.props.loginObj && this.props.loginObj.login && this.props.loginObj.token !== undefined) {
            return (
                <div className="hidden-scroll" id='token'>
                    <div className={`NewHeader`}
                    >
                        <div className='NewHeader_main'>
                            <div className="header-logo-panel">
                                <Link to='/Guide'>
                                    <img alt='logo' className="header-logo-img" src={this.state.imgUrl}></img>
                                </Link>
                                {/*<Link to='/Guide'>*/}
                                <Link className={'header-title-text'} to='/Guide'>
                                    <div className={'NewHeader_TitleText_cn'}>
                                        {this.state.titleCn}
                                    </div>
                                    <div className={'NewHeader_TitleText_en'}>
                                        {this.state.titleEn}
                                    </div>
                                </Link>
                                {/*</Link>*/}
                            </div>
                            <div className='header-menu-panel'>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "space-evenly"
                                }}>
                                    {/* 导航栏模块循环渲染 */}
                                    {
                                        this.renderHeadTitle()
                                    }
                                </div>
                            </div>
                            <div className='header-user-panel'>
                                <div className="NewHeader_userRight">
                                    <Dropdown
                                        overlay={usermenu}
                                    >
                                        <div className="NewHeader_userName">
                                            <Avatar className='NewHeader_userNameAvatar' src={user.avatar}></Avatar>
                                            <div className="NewHeader_userNameText"
                                                title={user.realName}>{this.returnLessUserName(user.realName)}</div>
                                        </div>
                                    </Dropdown>
                                    <Dropdown
                                        overlay={messagemenu}
                                    >
                                        {/* <div className="NewHeader_userName2" >消息(2)</div> */}
                                        <Badge dot={this.props.unReadMsg}>
                                            <div className="NewHeader_message">
                                                <img className="NewHeader_messageIcon"
                                                    src="images/tempImgs/message.png" />
                                            </div>
                                        </Badge>
                                    </Dropdown>
                                    <Link to='/Shopping' style={{ color: 'white' }}><ShoppingCartOutlined className="NewHeader_shopIcon" /></Link>
                                </div>
                            </div>
                        </div>
                        {/* <div className='newheader_toNewPage' onClick={this.jumpToNewPage}>
                            区域合作
                        </div> */}
                    </div>
                </div>

                // </div> 
            )
        } else //未登录状态统一退回到home （除非是在"用户注册" ‘登录’界面）
            // if (this.props.match.url === "/UserRegister") {
            // return <Redirect path='/Login' to="/UserRegister" />
            // } else {
            return <Redirect path='/Login' to='/Home' />
        // }
    }

    returnLessUserName = (name) => {
        if (name && name.length > 6) return name.substring(0, 4) + "...";
        else return name;
    }

    jumpToNewPage = () => {
        window.location = "http://10.0.37.25:8148/#/about";
        // window.open("http://10.0.37.25:8148/#/about");
    }

    openWebPage = (num) => {
        switch (num) {
            case 0:
                window.open("https://www.baidu.com/");
                break;
            case 1:
                window.open("https://cn.bing.com/");
                break;
            case 2:
                window.open("https://www.so.com/");
                break;
            default:
                break;
        }
    }
}

/**
 *
 * @param {*} state 代表外部传来的数据
 */
const mapState = (state) => ({ //返回值对应的是组件的props
    // loginStatus: state.loginreducer.loginstate,
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS(),
    unReadMsg: state.userReducer.get('userMsg')
    // userName: state.loginreducer.userName
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({
    //组件中的方法名称 组件通过this.props.fucname(para1,para2)来调用方法
    // { type: 'increase' }定义了外部对这个方法的描述信息，
    // login: (userName, password) => dispatch({ type: 'login', userName: userName }),
    // logout: () => dispatch({ type: 'logout' })
    login: (param) => dispatch(login(param)),
    logout: (user) => dispatch(logout(user))
})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
/**
 * 白色主题
 */
export default connect(mapState, mapDispatch)(withRouter(Header3));